import { Injectable, Optional } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';


export class ApiServiceConfig {
  url:string;
  projectId: string
}

@Injectable()
export class ApiServerService_old {
  private url: string = '';
  private projectId: string = '';
  private version = '1.0.0'

  constructor(
    private httpClient: HttpClient,
    @Optional() config?: ApiServiceConfig, private auth?: Auth,
  ) {
    if (config){
      this.url = config.url;
      this.projectId = config.projectId;
    }
  }

  info(){
    console.log("---- ApiServer ---");
    console.log("version  : ", this.version);
    console.log("url      : ", this.url);
    console.log("projectId: ", this.projectId);
    console.log("------------------");
  }
  /**
   *
   * @param path String with path Ex. 'search'
   * @param body any depends of Path
   * @param options {isBlob:booelan}
   * @returns Promise of Data
   */
  rq(path, body, _options?:{
    isBlob?:boolean;
  }): Promise<any>{
    const currentUser = this.auth.currentUser;
    if(currentUser){
      return currentUser.getIdToken(/* forceRefresh */ false).then(idToken => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${idToken}`,
          'project-id' : `${this.projectId}`
        });
        const options = {headers, body} as any;
        if (_options?.isBlob){
          options.responseType = 'blob';
          options.observe = 'response';
        }
        return firstValueFrom(this.httpClient.request('POST', this.url + path, options));
      })
    } else{
      return Promise.reject(new Error('fail-invalid currentUser'));
    }
  }
  /**
   * Used for Dashboards with a common filter
   * @param paths array of paths
   * @param terms common Filter for all paths
   * @returns Promise with result of all paths
   */
  bulkRq(paths, terms){
    const arrQry=[];
    paths.forEach(path=>arrQry.push(this.rq(path, terms)));
    return Promise.all(arrQry);
  }



}
